import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from 'src/app/core/login/authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(): boolean {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && (currentUser.tokenTrafico && (currentUser.loginTaxis || currentUser.codempleado))) {
            const route = currentUser.codempleado
                ? 'conductores/listado-servicios'
                : 'taxis/form';
            this.router.navigate([route]);
            return false;
        }
        return true;
    }
}